import { Component, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResetDialogComponent } from '../reset-dialog/reset-dialog.component';
import { TabDataService } from '../../service/tab-data.service';
import { ConstantConfig, ENABLE_PLAYGROUND_PROMPT_ROLE, ENABLE_SYSTEM_PROMPT_TYPE } from '../../utility/constant-config';
import { PlatformRegionService } from '../../../app/service/shared/platform-region.service'
import { catchError, map, of, takeUntil } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { SystemPromptDialogComponent } from '../system-prompt-dialog/system-prompt-dialog.component';
import { ToastrService } from 'ngx-toastr';
interface Tab {
  tabLabel: string;
  label: string;
  content: string;
  isEditing: boolean;
  api?: string;
  updated_date: string;
  updated_by: string;
  version_list: any;

}
interface MergedItem {
  tabLabel: string;
  label: string;
  content: string;
  isEditing: boolean;
  api?: string;
  updated_date: string;
  updated_by: string;
  version_list: any;
}

@Component({
    selector: 'app-system-prompt-tab',
    templateUrl: './system-prompt-tab.component.html',
    styleUrl: './system-prompt-tab.component.scss',
    standalone: false
})
export class SystemPromptTabComponent {

  tabs: Tab[] = [];
  config: any = ConstantConfig;
  roleName: string;
  enableTab = ENABLE_SYSTEM_PROMPT_TYPE;
  enableRole = ENABLE_PLAYGROUND_PROMPT_ROLE;
  isLoading = false;
  isNoData = false;
  errorMessage: string | null = null;
  versionForm: any;
  versions: any = [];
  constructor(public dialog: MatDialog, public toaster: ToastrService,
    private tabDataService: TabDataService, private cdr: ChangeDetectorRef,
    private PlatformRegionService: PlatformRegionService, public fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.loadContent();
    this.versionForm = this.fb.group({
      versionDrop: [''],
    });
  }

  loadContent() {
    this.roleName = sessionStorage.getItem('role');
    let product_code = sessionStorage.getItem('businessUnitCode') || '';
    let selectedRegion = this.PlatformRegionService?.selectedRegion?.name || '';

    this.isLoading = true;
    this.isNoData = false;
    this.errorMessage = null;

    this.tabDataService.getTabsData(product_code, selectedRegion).pipe(
      map(response => response || []),
      catchError(err => {
        console.error('Error loading tabs', err);
        this.errorMessage = 'Failed to load tabs. Please try again later.';
        // return empty array so subscription logic continues
        return of([]);
      }),
    ).subscribe((data: any[]) => {
      const requiredLabels = [
        { tabLabel: "Chat", label: "Chat", api: "Chat" },
        { tabLabel: "Playground", label: "playground", api: "playground" },
        // { tabLabel: "Summarizer", label: "Summarizer", api: "Summarizer" },
        { tabLabel: "Playground-b", label: "playground-b", api: "playground-b" },
        { tabLabel: "RolePlay", label: "role-play", api: "role-play" }
      ];

      if (!Array.isArray(data) || data.length === 0) {
        this.tabs = [];
        this.isNoData = true;
        this.isLoading = false;
        return;
      }

      const baseTabs = requiredLabels
        .map(label => {
          const found = data.find(item => item.config_module === label.api);

          // If role allowed, include only enabled tabs
          if (this.enableRole.includes(this.roleName || '')) {
            if (!this.enableTab.includes(label.label)) {
              return undefined;
            }
          }

          if (found) {
            return {
              tabLabel: label.tabLabel,
              label: label.label,
              api: label.api,
              content: found.system_prompt || '',
              isEditing: false,
              updated_by: found.created_by_name,
              updated_date: found.updated_date,
            } as Tab;
          } else {
            return undefined;
          }
        })
        .filter((item): item is Tab => !!item);

      this.isNoData = baseTabs.length === 0;
      this.tabDataService.versionList().subscribe(res => {
        const merged: MergedItem[] = baseTabs.map(a => {
          const match = res.find(b => b.config_module === a.label.toLowerCase());
          if (!match) return undefined;
          return { ...a, version_list: match?.version_list };
        }).filter((x): x is MergedItem => x !== undefined);
        this.tabs = merged;
        this.isLoading = false;
      });
    });
  }

  changeVersion(e, tab) {
    var V_value = e.value.split('_')
    var Res;
    this.tabDataService.SystemPromptByVersion(V_value[1]).subscribe(res => {
      Res = res;
      this.versionForm.controls['versionDrop'].setValue(e.value);
      const obj = {
        version: e.value,
        systemPrompt: Res.system_prompt,
        created_by_name: Res.created_by_name,
        created_date: Res.created_date
      }
      const systemPromptDialogRef = this.dialog.open(SystemPromptDialogComponent, {
        data: { tab: tab, object: obj },
        width: '1400px',
      });

      systemPromptDialogRef.afterClosed().subscribe(result => {
        this.versionForm.get('versionDrop')?.reset();
      });
    });
  }

  enableEditing(tab: Tab): void {
    tab.isEditing = true;
    this.cdr.detectChanges();
    sessionStorage.setItem('tabContent', tab.content);
    const textarea = document.getElementById(`textarea-${tab.label}`);
    if (textarea) {
      this.resizeTextarea(textarea);
    }
  }

  cancelEditing(tab: Tab): void {
    this.loadContent();
    // tab.isEditing = false;
  }

  submitEditing(tab: Tab): void {
   const Content = sessionStorage.getItem('tabContent');
   if(Content === tab.content){
    this.toaster.warning('No changes made to the System Prompt', '', { positionClass: 'toast-top-right' });
    return;
   }else{
    tab.isEditing = false;
    this.tabDataService.updateTab(tab).subscribe(updatedTab => {
      Object.assign(tab, updatedTab);
      this.toaster.success('System Prompt saved successfully', '', { positionClass: 'toast-top-right' });
      tab.isEditing = false;
      this.loadContent();
    });
  }
  }

  onReset(tab: Tab): void {
    const resetDialogRef = this.dialog.open(ResetDialogComponent);

    resetDialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          business_unit_code: sessionStorage.getItem('businessUnitCode'),
          created_by: Number(sessionStorage.getItem('userId')),
          config_module: tab.api
        }
        this.tabDataService.resetTabContent(tab).subscribe(resetTab => {
          tab.content = resetTab.system_prompt || '';
          tab.updated_by = resetTab.created_by_name;
          tab.updated_date = resetTab.updated_date;
          this.loadContent();
        });
        this.toaster.success('System Prompt reset successfully', '', { positionClass: 'toast-top-right' });
      }
    });
  }

  resizeTextarea(textarea: any): void {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }
}

